import React, { Component } from "react";
import ReportList from "./reportList";
import Pdfexport  from "./Pdfexport";
import { Switch, Route, Link, BrowserRouter } from "react-router-dom";
import { Redirect } from 'react-router';

class viewreport extends Component {
  componentDidMount() {
    this.props.func();
    // console.log(this.props.state.report[0].templateList);
  }
  render() {
    if (localStorage.getItem("UserData") === null) {
      return <Redirect to={'/signin'} />;
    }
    var retrievedData =  localStorage.getItem('UserData');
    var data = JSON.parse(retrievedData);
    if (data.token == null) {
      return <Redirect to={'/signin'} />;
    }
    return (
      <React.Fragment>
        <div className="row">
          <header>
            <div className="container-fluid">
              <div className="row header-height">
                <div className="col s12">
                  <Link to={"inspection"}>
                    <button class="btn waves-effect waves-light B1-filter">
                      <i class="material-icons left">arrow_back</i>Back to list{" "}
                    </button>
                  </Link>
                  <button class="btn waves-effect waves-light B1-filter">
                    <i class="material-icons left">filter_list</i>Filter{" "}
                  </button>
                 
                 
                  <button class="btn waves-effect waves-light B2-share">
                    <i class="material-icons left">attachment</i>Share{" "}
                  </button>
                </div>
              </div>
            </div>
          </header>
        </div>
        <div class="row" style={{ background: "rgb(250, 250, 250)" }}>
          <div class="col s12 m4 l2 " style={{ height: "97vh" }}>
            <ul id="menu" className="menu-report">
              {this.props.state.report[0].templateList.map((value, index) => {
                return (
                  <a href="#" class="">
                    <li>{value.name}</li>
                  </a>
                );
              })}
              {/* <a href="#" class="bold-li"><li><b>Overview</b></li></a>
                    <a href="#" class="bold-li"><li><b>Workplace Checklist for COVID-19 Preparedness</b></li></a>
                    <a href="#" class=""><li>Planning Ahead</li></a>
                    <a href="#" class=""><li>Cleaning</li></a>
                    <a href="#" class=""><li>Handwashing and Hygiene</li></a>
                    <a href="#" class=""><li>Physical Distancing</li></a>
                    <a href="#" class=""><li>Monitoring Symptoms</li></a>
                    <a href="#" class=""><li>Working From Home</li></a>
                    <a href="#" class="bold-li"><li><b>Summary</b></li></a> */}
            </ul>
          </div>
          <div class="col s12 m8 l9  left-align">
            <div
              className="container"
              style={{ marginTop: "30px", marginLeft: "50px" }}
            >
              <Pdfexport list={this.props.state} />
            </div>
          </div>
        </div>
        
      </React.Fragment>
    );
  }
}
export default viewreport;
